
import {BASE_URL,BROADCAST_LIST,GET } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";

export const fetchBroadcastList = async (next,status="",orderBy="") => {
    const token = await getAccessToken();
    let url = `${BASE_URL}${BROADCAST_LIST}`;

  let array = [
    {
      key:"status",
      value:encodeURIComponent(status)
    },
    {
      key:"orderBy",
      value:encodeURIComponent(orderBy)
    },
    {
      key:"next",
      value:next
    } 
  ]  

  let queryString=``;
  array.forEach((item)=>{
    if(item.value){
      if(queryString){
        queryString=queryString+`&${item.key}=${item.value}`
      }else{
        queryString=`${item.key}=${item.value}`
      }
    }
  })

  if(queryString){
    url=`${url}?${queryString}`;
    url = url.replace ("filter=&", "");
}
    const response =  fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
      
      return response;

};